export default {
  // START:: GET APP LOCALE
  getAppLocale(state) {
    return state.modo_dashboard_language;
  },
  // END:: GET APP LOCALE
};
